'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/button/style/css');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _css2 = require('antd/lib/modal/style/css');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _template = require('../actions/template');

var _utils = require('../utils');

var _constants = require('../constants');

var _template_list = require('../components/template_list');

var _template_list2 = _interopRequireDefault(_template_list);

var _template_filter = require('../components/template_filter');

var _template_filter2 = _interopRequireDefault(_template_filter);

var _with_product_type = require('../hocs/with_product_type');

var _with_product_type2 = _interopRequireDefault(_with_product_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Templates = _react2.default.createClass({
    displayName: 'Templates',

    propTypes: {
        templates: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _template.fetchTemplatesIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _template.fetchTemplatesIfNeeded)(filter));
    },
    onChange: function onChange(name, value) {

        this.props.dispatch((0, _template.filterTemplates)(_defineProperty({}, name, value)));
    },
    handleStatusChange: function handleStatusChange(id, oldStatus) {
        var _props2 = this.props,
            dispatch = _props2.dispatch,
            filter = _props2.filter,
            router = _props2.router;

        var status = oldStatus === 1 ? 0 : 1;
        dispatch((0, _template.postTemplateIfNeeded)({ id: id, status: status }, router));
    },
    handleDelete: function handleDelete(id) {
        var _props3 = this.props,
            dispatch = _props3.dispatch,
            router = _props3.router;

        _modal2.default.confirm({
            title: '确认删除?',
            onOk: function onOk() {
                dispatch((0, _template.deleteTemplateIfNeeded)(id, router));
            },
            onCancel: function onCancel() {}
        });
    },
    render: function render() {
        var _props4 = this.props,
            filter = _props4.filter,
            templates = _props4.templates,
            productTypes = _props4.productTypes;

        return _react2.default.createElement(
            'div',
            { id: 'templates', className: 'clearfix' },
            _react2.default.createElement(
                _button2.default,
                { type: 'primary', className: 'create' },
                _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/templates/create' },
                    '\u521B\u5EFA\u6A21\u7248'
                )
            ),
            _react2.default.createElement(_template_filter2.default, { status: _constants.PRODUCT_STATUS, types: productTypes, onChange: this.onChange, filter: filter }),
            _react2.default.createElement(_template_list2.default, { templates: templates,
                handleStatusChange: this.handleStatusChange,
                handleDelete: this.handleDelete })
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$template = store.template,
        templates = _store$template.templates,
        filter = _store$template.filter;
    var productTypes = store.productType.productTypes;

    return {
        templates: templates,
        filter: filter,
        productTypes: productTypes.items
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)((0, _with_product_type2.default)(Templates));


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/templates.js
// module id = 1337
// module chunks = 0